import { defineStore } from 'pinia';
import { state } from './state.js';
import { getters } from './getters.js';
import { actions } from './actions.js';

export const usePlayerStore = defineStore('player', {
  state,
  getters,
  actions,
});
